/**
 * Backend API base URL (no trailing slash).
 * Set REACT_APP_API_URL at build time (Docker / production).
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3000";
